import PaymentSettings from './PaymentSettings'

export * from './PaymentSettings'

export default PaymentSettings
